var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("router-link", { attrs: { to: _vm.routerPath, tag: "a" } }, [
    _vm._v(_vm._s(_vm.value)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }